<template>
  <div class="type_manage" >
    <el-row style="margin-bottom: .4rem">
      <el-col>
        <el-button type="primary" size="small" @click="handleAddCustomerBelongsOpen">添加</el-button>
        <el-button type="primary" size="small" @click.native="$router.push('setting_panel')">返回上一级</el-button>
      </el-col>
    </el-row>
    <el-table :data="fromDatas" size="medium" style="width: 100%" border>
      <el-table-column label='id' prop="id"></el-table-column>
      <el-table-column label='客户隶属' prop="name"></el-table-column>
      <el-table-column prop="sort" label="排序">
        <template slot-scope="scope">
          <el-input type="number" size="mini" v-model="listSort[scope.row.id]" @blur="setSort(scope.row)"></el-input>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEditCustomerBelongs(scope.$index, scope.row)">编辑</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination background class="tr mt-10" layout="total, prev, pager, next, jumper" :hide-on-single-page="false"
      :current-page="pageOptionCustomerBelongs.currentPage" :page-sizes="[10, 20]" :page-size="pageOptionCustomerBelongs.pageSize"
      :total="pageOptionCustomerBelongs.total" @size-change="handleSizeChangeCustomerBelongs"
      @current-change="handleCurrentChangeCustomerBelongs">
    </el-pagination>
    <el-drawer title="添加客户隶属" :visible.sync="addCustomerBelongsDrawer" direction="rtl"
      :before-close="handleCloseAddCustomerBelongs" size="40%">
      <div class="m-tabs-content">
        <el-card class="box-card" style="margin-bottom: .2rem;">
          <el-divider content-position="left">客户隶属</el-divider>
            <el-row>
              <el-col :span="14">
                <el-input placeholder="请输入客户隶属" size="mini" v-model="addCustomerBelongs.from" clearable>
                </el-input>
              </el-col>
              <el-col :span="4" :offset="1">
                <el-button type="primary" size="mini" @click="handleAddCustomerBelongs">添加</el-button>
              </el-col>
            </el-row>
        </el-card>
      </div>
    </el-drawer>
    <el-drawer title="编辑客户隶属" :visible.sync="editCustomerBelongsDrawer" direction="rtl"
      :before-close="handleCloseEditOrderFrom" size="40%">
      <div class="m-tabs-content">
        <el-card class="box-card" style="margin-bottom: .2rem;">
          <el-divider content-position="left">客户隶属</el-divider>
          <el-row>
            <el-col :span="14">
              <el-input v-model="updateCustomerBelongs.from" size="mini" clearable></el-input>
            </el-col>
            <el-col :span="4" :offset="1">
              <el-button type="primary" size="mini" @click="handleSaveCustomerBelongs">保存</el-button>
            </el-col>
          </el-row>
        </el-card>
      </div>
    </el-drawer>
  </div>
</template>
<script>
export default {
  name: 'CustomerBelongs',
  data () {
    return {

      listSort: [],
      fromDatas: [],
      addCustomerBelongsDrawer: false,
      inputSize: 'small',
      direction: 'rtl',
      pageOptionCustomerBelongs: {
        pageSize: 10,
        currentPage: 1,
        total: 0
      },
      addCustomerBelongs: {
        from: ''
      },
      updateCustomerBelongs: {
        index: null,
        id: null,
        from: ''
      },
      editCustomerBelongsDrawer: false
    }
  },
  computed: {  
    collapse () {
      return this.$store.state.collapse
    }
  },
  methods: {
    getFroms () {
      this.$axios.get('api/admin/get_customer_belongs?page=' + this.pageOptionCustomerBelongs.currentPage)
        .then((res) => {
          let { data } = res
          if (data.code === 0) {
            this.fromDatas = data.data.data.data
            this.pageOptionCustomerBelongs.total = data.data.data.total
            this.loadSort()
          }
        })
    },
    handleSizeChangeCustomerBelongs (val) {
      this.pageOptionCustomerBelongs.pageSize = val
    },
    handleCurrentChangeCustomerBelongs (val) {
      this.pageOptionCustomerBelongs.currentPage = val
      setTimeout(() => {
        this.getFroms()
      })
    },
    handleCloseAddCustomerBelongs (done) {
      done()
    },
    handleAddCustomerBelongs () {
      if (!this.addCustomerBelongs.from) {
        this.$message.error('请输入客户隶属！')
        return
      }
      this.$axios.post('api/admin/add_customer_belongs', {from: this.addCustomerBelongs})
        .then((res) => {
          let { data } = res
          if (data.code === 0) {
            this.addCustomerBelongs.from = ''
            this.addCustomerBelongsDrawer = false
            this.getFroms()
            this.$message.success(data.msg)
          }
        })
    },
    handleEditCustomerBelongs (index, row) {
      this.updateCustomerBelongs.index = index
      this.updateCustomerBelongs.id = row.id
      this.updateCustomerBelongs.from = row.name
      this.editCustomerBelongsDrawer = true
    },
    handleSaveCustomerBelongs () {
      if (!this.updateCustomerBelongs.from) {
        this.$message.error('客户隶属不能为空！')
        return
      }
      this.$axios.post('api/admin/edit_customer_belongs', {from: this.updateCustomerBelongs})
        .then((res) => {
          let { data } = res
          if (data.code === 0) {
            this.fromDatas[this.updateCustomerBelongs.index].name = this.updateCustomerBelongs.from
            this.clearUpDataOrderFrom()
            this.editCustomerBelongsDrawer = false
            this.$message.success(data.msg)
          }
        })
    },
    clearUpDataOrderFrom () {
      this.updateCustomerBelongs.index = ''
      this.updateCustomerBelongs.id = ''
      this.updateCustomerBelongs.from = ''
    },
    handleCloseEditOrderFrom (done) {
      this.clearUpDataOrderFrom()
      done()
    },
    handleAddCustomerBelongsOpen () {
      this.addCustomerBelongsDrawer = true
    },
    setSort (row) {
      if (isNaN(this.listSort[row.id])) {
        this.$message.error('排序值为数字！')
        return false
      }
      this.$axios
        .post('api/admin/customer_belongs/edit_sort', {
          id: row.id,
          sort: this.listSort[row.id]
        })
        .then(res => {
          const { data } = res
          if (data.code === 0) {
            this.$message.success(data.msg)
            this.getFroms()
          } else {
            this.$message.error(data.msg)
          }
        })
        .catch()
    },
    loadSort () {
      this.fromDatas.map(item => {
        this.listSort[item.id] = Number(item.sort)
      })
    }
  },
  mounted () {
    this.getFroms()
  }
}
</script>

<style scoped lang="stylus">
  @import '~styles/varibles.styl'
  @import '~styles/vertical.styl'
  @import '~styles/icon.styl'
  .el-drawer__wrapper >>> .el-drawer
    overflow-y: auto
  .el-drawer__wrapper >>> .el-drawer__header span
    color: #4c87fc
    font-size 0.36rem
    font-weight 400
  .type_manage
    marginLeft()
  .mt-10
    margin-top: .2rem
  .tr
    text-align: right
  .m-tabs-content
    padding: 0 .2rem 0 .4rem
    overflow-y auto
    .m-label
      line-height: .64rem
    .el-row
      margin-bottom: .4rem
    .el-date-editor.el-input, .el-date-editor.el-input__inner
      width: 100%
    .el-select
      width: 100%
  .type_manage >>> .el-table__header th
    color: #333333
    background-color: #ECF4FF
  .addCon
    padding: .2rem
    text-align: right
  .count_style
    display: inline-block
    overflow: hidden
    text-overflow: ellipsis
    white-space: nowrap
</style>



// WEBPACK FOOTER //
// src/pages/setting_panel/CustomerBelongs.vue